import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DetailsCard } from "components";
import { CommunicationLogs } from "modules/AppointmentDetails/components/DeskCommunicationLog/components";
import "modules/AppointmentDetails/components/DeskCommunicationLog/DeskCommunicationLog.scss";

import type { Appointment } from "models";

type DeskCommunicationLogProps = {
  appointment: Appointment;
};

export const DeskCommunicationLog = ({ appointment }: DeskCommunicationLogProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleIsModalOpen = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    setIsModalOpen(!isModalOpen);
  };

  const { desk_communications } = appointment;

  if (!desk_communications?.length) return null;

  return (
    <>
      <div className="DeskCommunicationLog" onClick={handleToggleIsModalOpen}>
        <DetailsCard title={t("v8_desk_comm_log", "Desk Communication Log")} icon="user" rightContent={null} showExpandArrow={false} button />
      </div>
      <CommunicationLogs appointment={appointment} isModalOpen={isModalOpen} onToggleIsModalOpen={handleToggleIsModalOpen} />
    </>
  );
};
